import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';
export var SimpleFooter = function SimpleFooter() {
  return 1 > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(DefaultFooter, {
    style: {
      height: 24,
      backgroundColor: 'white'
    },
    copyright: false
  });
};